<template>
    <v-dialog persistent v-model="dialog" width="400">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">انتخاب شماره تماس</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list>
                <template v-for="(item, i) in items">
                    <v-list-item @click="makeCall(i)">
                        <template v-slot:prepend>
                            <v-icon color="primary" size="20">{{ item.icon }}</v-icon>
                        </template>
                        <v-list-item-title>{{item.text}}</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="i !== items.length - 1"></v-divider>
                </template>
            </v-list>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            items: [],
        };
    },
    methods: {
        async makeCall(index) {
            let called = false;
            if (this.$system.systemSettings.voip_active && this.$auth.user.interphone) {
                let res = await this.$makeCall({number: this.items[index].text});
                if(res && res.status == 'OK' && res.data?.called)
                    called = true;
            }
            this.dialog = false;
            if (called) {
                this.$toast.success('تماس در حال برقراریست');
            } else {
                window.location.href = `tel://${this.items[index].text}`;
            }
        },
        hasNumber() {
            return !!this.items.length;
        },
        userHasNumber(user) {
            if (user.mobile)
                return true;
            if (user.landline)
                return true;
            if (user.employee && user.interphone)
                return true;
            if (!user.employee && user.other_phones?.length)
                return true;
            return false;
        },
        calculateNumbers(user) {
            this.items = [];
            if (user.mobile)
                this.items.push({icon: 'icon-mobile2', text: user.mobile});
            if (user.landline)
                this.items.push({icon: 'icon-phone-office', text: user.landline});
            if (user.employee && user.interphone)
                this.items.push({icon: 'icon-phone-office', text: user.interphone})
            if (!user.employee && user.other_phones?.length)
                this.items = this.items.concat(user.other_phones.map(x => {return {icon: 'icon-call-outgoing', text: x}}));
        }
    },
};
</script>
